/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Level_SuccessInputs */

const en_usage_level_success = /** @type {(inputs: Usage_Level_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Success`)
};

const zh_hans1_usage_level_success = /** @type {(inputs: Usage_Level_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成功`)
};

const pt_br2_usage_level_success = /** @type {(inputs: Usage_Level_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sucesso`)
};

const es_usage_level_success = /** @type {(inputs: Usage_Level_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correcta`)
};

const fr_usage_level_success = /** @type {(inputs: Usage_Level_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Succès`)
};

const de_usage_level_success = /** @type {(inputs: Usage_Level_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfolg`)
};

const ru_usage_level_success = /** @type {(inputs: Usage_Level_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Успешно`)
};

const it_usage_level_success = /** @type {(inputs: Usage_Level_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riuscita`)
};

/**
* | output |
* | --- |
* | "Success" |
*
* @param {Usage_Level_SuccessInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const usage_level_success = /** @type {((inputs?: Usage_Level_SuccessInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Level_SuccessInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_usage_level_success(inputs)
	if (locale === "pt-BR") return pt_br2_usage_level_success(inputs)
	if (locale === "es") return es_usage_level_success(inputs)
	if (locale === "fr") return fr_usage_level_success(inputs)
	if (locale === "de") return de_usage_level_success(inputs)
	if (locale === "ru") return ru_usage_level_success(inputs)
	if (locale === "it") return it_usage_level_success(inputs)
	return en_usage_level_success(inputs)
});